// extracted by mini-css-extract-plugin
module.exports = {"infoSwitch":"_3wlW2Ov0x_tSG0HpYUbKn8","switchButton":"_3ZUPAc0VJMwGv1QOCiDefW","active":"DEcQExcWD4Q97wjO4Nd69"};